import { keys } from '@uniformdev/common';
export function popVisibleRenderingsFromPlaceholdersMap(placeholders, placeholderKey, logger) {
    var visibleRenderings = [];
    keys(placeholders).forEach(function (x) {
        if (false ||
            // --------------------------------------------------------
            // Exact match
            //   e.g. '/main/content' matches '/main/content'
            //
            x == placeholderKey ||
            // --------------------------------------------------------
            // Loose placeholder
            //   e.g. 'content' matches '/main/content'
            //   but not '/main-content' and not '/main/content/top'
            //
            (!x.startsWith('/') && placeholderKey.endsWith('/' + x)) ||
            // --------------------------------------------------------
            false) {
            var renderings = placeholders[x];
            renderings.forEach(function (r) {
                if (!r || r.hidden)
                    return;
                logger.debug('Adding ' +
                    r.componentName +
                    ' [' +
                    r.id +
                    '] to ' +
                    placeholderKey);
                visibleRenderings.push(r);
            });
        }
    });
    return visibleRenderings;
}
//# sourceMappingURL=popVisibleRenderingsFromPlaceholdersMap.js.map